<template>
  <Modal
    v-model="openForm"
    title="班次作业量"
    footer-hide
    fullscreen
  >
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(130)"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </Modal>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm:false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "作业日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
        },
        {
          title: "线路名称",
          key: "lineName",
        },
        {
          title: "路段标签",
          key: "lable",
        },
        {
          title: "排班开始",
          key: "startTime",
        },
        {
          title: "排班结束",
          key: "endTime",
        },
        {
          title: "实际开始",
          key: "startTimeReal",
        },
        {
          title: "实际结束",
          key: "endTimeReal",
        },
        {
          title: "应作业里程/km",
          key: "jobMileage",
        },
        {
          title: "实际作业里程/km",
          key: "jobMileageReal",
        },
        {
          title: "作业完成率/%",
          key: "finishPercent",
        },
        {
          title: "作业状态",
          render: (h, data) => {
            return h("div", this.$t("workStatus." + data.row.status));
          },
        },
        
      ],
      tableData: [],
      total: 0,
      searchItem: {
        startDate: "",
        endDate: "",
        lineId: "",
        pageNumber: 0,
        pageSize: 0,
      },
    };
  },
  methods: {
    reachData(v) {
      this.openForm=true;
      this.searchItem.startDate=v.startDate;
      this.searchItem.endDate=v.endDate;
      this.searchItem.lineId=v.lineId;
      this.getList()
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.work + "/carJobReport/carJobReportLineClass",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      console.log(this.keyWork);
      this.reset();
      this.getList();
    },
    reset() {},
  },

};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/work/classWorks.vue